import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import Products from '../Components/Products';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import add from '../Images/add-square.png';
import TrophyIcon from '../Images/cup.svg'; 
import TruckIcon from '../Images/car.svg'; 
import TagIcon from '../Images/wallet.png';
import RateImage from '../Images/rate.png';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    const handleClick = () => {
        navigate('/product', {
          state: { 
            scrollToPromo: true,
            productId: product.id,  // Pass the product.id here
          },
        });
      };



    return (
        <div className="flex flex-col items-start bg-white rounded-lg shadow-lg mx-2 my-2 cursor-pointer" onClick={handleClick}>
            <div className="w-full">
                <img src={product.default_image} alt={product.name} className="w-full h-auto object-cover mb-4" />
            </div>
            <div className="text-start pl-5">
                <h3 className="text-md mb-2" style={{ fontFamily: 'arial' }}>{product.name}</h3>
                <p className="text-xs mr-2 mb-7" style={{ fontFamily: 'arial', color: '#8C8C8C' }}>
  {product.brief.length > 150
    ? `${product.brief.slice(0, 150)}...`
    : product.brief}
</p>                <div className="flex flex-row items-center justify-between mb-5 gap-10">
                    <p className=" " style={{ fontFamily: 'arial', fontSize:'13px' }}>{`From £${product.start_price}`}</p>
                    <div className="flex flex-row items-center gap-2">
                        <p className="" style={{ color: '#EC008C', fontFamily: 'arial', fontSize:'13px' }}>
                            Shop Now
                        </p>
                        <button>
                            <img src={add} className="w-4 h-4 mr-2" alt="Add" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SliderCollection = ({ collectionName, collectionDescription, collectionBanner  }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        (
            <div className="px-6 flex flex-col md:flex-row justify-between items-center "
                style={{
                    backgroundImage: `url(https://backend.printtrio.co.uk/${collectionBanner})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    aspectRatio: '16 / 6',
                }}
            >
                <div className="flex-1  mr-28 md:mr-0 mt-10">
                    <h1 className="text-white font-bold text-xl md:text-4xl xl:text-6xl leading-tight mb-4 px-0 xl:px-20  ">
                    {collectionName}
                    </h1>
                    <p className="text-white text-xs md:text-base text-opacity-80 mb-6 px-0 xl:px-20 max-w-2xl">
                    {collectionDescription}
                    </p>
                    {/* <div className="flex flex-row justify-start text-center gap-3 px-20 mb-8">
                        <p className="font-medium" style={{ fontFamily: 'arial', color: 'white' }}>Excellent</p>
                        <img src={RateImage} alt='RateImage' className="w-32 h-6" />
                    </div> */}
                </div>
            </div>
        ),
    ];

    return (
        <div className="w-full h-full flex flex-col justify-center max-w-screen-xl mx-auto">
           
    <div className="px-0 xl:px-0">
            {slides[currentSlide]}
            <div className="flex items-center justify-end space-x-2">
                {slides.map((_, index) => (
                    <span key={index}
                        style={{
                            width: currentSlide === index ? '20px' : '8px',
                            backgroundColor: currentSlide === index ? '#ec008c' : 'white',
                            opacity: currentSlide === index ? '2' : '0.5',
                        }}
                    ></span>
                ))}
            </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-20 md:px-16 xl:px-22 space-y-12 md:space-y-0 bg-white py-8 md:py-8">
                <div className="flex flex-row items-center gap-4 pl-0 md:pl-1">
                    <img src={TrophyIcon} alt="Premium Quality" className="h-8 w-8" />
                    <p className="text-black text-xs xl:text-xl mt-2">Premium Quality Made In The UK</p>
                </div>
                <div className="flex flex-row items-center gap-4">
                    <img src={TruckIcon} alt="Fast Delivery" className="h-8 w-8" />
                    <p className="text-black text-xs xl:text-xl mt-2">Fast Production And Delivery</p>
                </div>
                <div className="flex flex-row items-center gap-4">
                    <img src={TagIcon} alt="Low Price" className="h-8 w-8" />
                    <p className="text-black text-xs xl:text-xl mt-2">Low Price And Low Quantity Orders</p>
                </div>
            </div>
        </div>
    );
};

const CollectionPage = () => {
    const location = useLocation();
    const promoBannerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    const { scrollToPromo, products, collectionName, collectionDescription, collectionBanner  } = location.state || {};

    useEffect(() => {
        if (location.state?.scrollToPromo && promoBannerRef.current) {
            window.scrollTo({
                top: promoBannerRef.current.offsetTop,
                behavior: 'smooth',
            });
        }
        const timer = setTimeout(() => {
            setIsLoading(false);
          }, 500); // you can adjust time if you want smoother
        
          return () => clearTimeout(timer); // clear timer if component unmounts
        }, [location]);

    return (
        <div>
            <div ref={promoBannerRef}>
                <PromoBanner />
            </div>
            <Navbar />
            {isLoading ? (
      <div className="flex justify-center items-center h-screen">
        {/* Tailwind simple spinner */}
        <svg
          className="animate-spin h-12 w-12 text-pink-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    ) : (
      <>
            <SliderCollection collectionName={collectionName} collectionDescription={collectionDescription} collectionBanner={collectionBanner} />
                        <div className="flex flex-col bg-gray-100 py-12 px-2 md:px-16 xl:px-48 max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
                <div className="relative mt-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
                        {products.map((product) => (
                            <div key={product.id}>
                                <ProductCard product={product} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Products />
            <Sample />
            <Subscribe />
            <FixedImageMessage />
            <Footer />
            </>
    )}
        </div>
    );
};

export default CollectionPage;
